var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasCreaAsta
        ? _c("div", { staticClass: "logo-bg" }, [
            _c("div", { staticClass: "view" }, [
              _c(
                "div",
                { staticClass: "crea-asta" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "navy darken-2 white--text py-4 px-8 ma-5",
                      attrs: { "max-width": "400" },
                    },
                    [
                      _c("h1", { staticClass: "text-center mb-5" }, [
                        _vm._v("Crea asta"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Nome lega/asta",
                              rules: [
                                _vm.rules.campoObbligatorio,
                                _vm.rules.nomeTroppoLungo(50),
                              ],
                              counter: "",
                              maxlength: "50",
                              "prepend-icon": "shield",
                              "persistent-hint": "",
                              required: "",
                              outlined: "",
                              dark: "",
                              "append-outer-icon": "lock_open",
                            },
                            model: {
                              value: _vm.astaName,
                              callback: function ($$v) {
                                _vm.astaName = $$v
                              },
                              expression: "astaName",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: [
                                2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
                                16, 17, 18, 19, 20,
                              ],
                              rules: [_vm.rules.campoObbligatorio],
                              label: "Numero squadre partecipanti",
                              "prepend-icon": "groups",
                              "append-outer-icon": "lock_open",
                              required: "",
                              outlined: "",
                              dark: "",
                            },
                            model: {
                              value: _vm.maxSquadre,
                              callback: function ($$v) {
                                _vm.maxSquadre = $$v
                              },
                              expression: "maxSquadre",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: _vm.getAstaRuoliSelectOptions(),
                              label: "Tipologia ruoli",
                              "prepend-icon": "tune",
                              "append-outer-icon": "lock_open",
                              required: "",
                              outlined: "",
                              dark: "",
                            },
                            model: {
                              value: _vm.tipologiaRuoli,
                              callback: function ($$v) {
                                _vm.tipologiaRuoli = $$v
                              },
                              expression: "tipologiaRuoli",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              label: "Crediti iniziali",
                              rules: [_vm.rules.creditiLega],
                              type: "number",
                              name: "creditiLega",
                              "prepend-icon": "local_atm",
                              "append-outer-icon": "lock_open",
                              "persistent-hint": "",
                              required: "",
                              outlined: "",
                              dark: "",
                            },
                            model: {
                              value: _vm.creditiLega,
                              callback: function ($$v) {
                                _vm.creditiLega = _vm._n($$v)
                              },
                              expression: "creditiLega",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: _vm.getAstaModesSelectOptions(),
                              label: "Modalità d'asta",
                              "prepend-icon": "gavel",
                              required: "",
                              outlined: "",
                              dark: "",
                              hint: "Non ti preoccupare della scelta adesso. Puoi cambiare in qualunque momento la modalità di un'asta",
                            },
                            model: {
                              value: _vm.mode,
                              callback: function ($$v) {
                                _vm.mode = $$v
                              },
                              expression: "mode",
                            },
                          }),
                          _vm._v(" "),
                          _c("h3", { staticClass: "text-center mb-3" }, [
                            _vm._v("La mia squadra"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c("v-col", { attrs: { cols: "3" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "myPic",
                                    class: _vm.myPicClass,
                                    on: { click: _vm.showDialog },
                                  },
                                  [
                                    _c("label", { staticClass: "label" }, [
                                      _vm._v("Logo"),
                                    ]),
                                    _vm._v(" "),
                                    _vm.myPic
                                      ? _c("img", { attrs: { src: _vm.myPic } })
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "9" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mb-4",
                                    attrs: {
                                      label: "Nome squadra",
                                      name: "myNomeSquadra",
                                      "persistent-hint": "",
                                      required: "",
                                      outlined: "",
                                      counter: "",
                                      maxlength: "50",
                                      rules: [
                                        _vm.rules.campoObbligatorio,
                                        _vm.rules.nomeTroppoLungo(50),
                                      ],
                                      dark: "",
                                    },
                                    model: {
                                      value: _vm.myNomeSquadra,
                                      callback: function ($$v) {
                                        _vm.myNomeSquadra = $$v
                                      },
                                      expression: "myNomeSquadra",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _vm._v(
                                "\n              Importante: I campi contrassegnati con\n              "
                              ),
                              _c("v-icon", { staticClass: "white--text" }, [
                                _vm._v("lock_open"),
                              ]),
                              _vm._v(
                                " non saranno più\n              modificabili una volta creata l'asta\n            "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-4" }, [
                            _vm._v(
                              "\n              Dopo aver creato l'asta, troverai però molte altre opzioni da\n              personalizzare\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "secondary white--text mt-4",
                              attrs: {
                                rounded: "",
                                depressed: "",
                                large: "",
                                id: "crea-asta",
                                disabled: !_vm.valid,
                              },
                              on: { click: _vm.createAsta },
                            },
                            [_vm._v("Crea Asta")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { eager: "", "max-width": "700" },
                      model: {
                        value: _vm.dialog,
                        callback: function ($$v) {
                          _vm.dialog = $$v
                        },
                        expression: "dialog",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "navy darken-1" },
                        [
                          _c("v-card-title", { staticClass: "white--text" }, [
                            _vm._v("Scegli logo"),
                          ]),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "pics",
                              class: { "nice-scroll": !_vm.is_mobile },
                            },
                            _vm._l(_vm.defaultPics, function (pic, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "pic navy darken-2",
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveMyPic(pic)
                                    },
                                  },
                                },
                                [_c("img", { attrs: { src: pic } })]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _c("NotFound"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }